import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteContact } from "@/api/v1-jwt/contact/contact";
import { useAuth } from "@/providers/auth";

export const useDeleteContact = () => {
  const query = useQueryClient();
  const { cognitoId, clientId, userRole } = useAuth();

  const id =
    userRole === "admin" || userRole === "auth_user" ? clientId : cognitoId;

  return useMutation({
    mutationFn: (contactId) => deleteContact({ userId: id, contactId }),
    onSuccess: () => {
      query.invalidateQueries(["contacts"]);
    },
  });
};
